import { trackForwardedComponent } from '@drone-js/core';
import { DatePicker as DatePickerMemoized } from './DatePicker.js';
export { BaseDatePicker } from './DatePicker.js';

var DatePickerWithTracking = trackForwardedComponent(DatePickerMemoized);

export { DatePickerWithTracking as DatePicker };
//# sourceMappingURL=external.js.map
